import React from 'react'
import { formatDate } from '../helper/formatDate';
import { CompareDate } from '../helper/CompareDate';
import { Link } from 'react-router-dom';
import PillBtn from './PillBtn';
import { aedLogoStyle, getDirhamImage } from '../common/cssclasses';
import { getFileName } from '../helper/getFileName';
import { formatLongDate } from '../helper/formatLongDate';



const BaseURL = process.env.REACT_APP_BASE_URL;
export default function ShowEntryCard({ i, item, translate, currentLanguage }) {
  return <div
    className="col-lg-6 col-md-12 col-sm-12 mb-main"
    key={i}
  >
    <div className="p-main bg-white border-15 p-3 h-100">
      <div className='row rtl'>
        <div className="col-lg-4 col-md-8 col-sm-12">
          <img
            className='w-100'
            src={item.logo}
            alt={getFileName(item?.logo)}
          />
        </div>

        <div className="col-lg-8 col-md-8 col-sm-12  ">
          {item.showParticipantRequestStatus ===
            "Returned" && (
              <div className="col-md-1 col-sm-12 textalignend">
                <i class="fa-solid fa-bell colorred red"></i>
              </div>
            )}
          <div className="col-md-12 col-sm-12 ">
            <div className="showNewTitle">
              {item.showName}
            </div>
          </div>
          <div class="showNewDetials">
            <div class="showNewRank showNewStartDate ">
              {!!item?.showRank &&
                <div>
                  <i class="fa fa-trophy red"></i> {item?.showRank}
                </div>
              }
              {!!item?.cityName &&
                <div>
                  <i class="fa-solid fa-location-dot red"></i>
                  {item?.cityName}
                </div>
              }
            </div>
            {item?.startDate && <div class="showNewRank showNewStartDate ">
              <div>
                <i class="fa fa-calendar red" ></i>{translate(
                  "web.startDate",
                  "Start Date"
                )}:
              </div>
              <div>{formatLongDate(item.startDate , true)}</div>
            </div>}
            {item.endDate &&
              <div class="showNewLocation showNewStartDate">
                <div>
                  <i class="fa fa-calendar red" ></i>
                  {translate("web.endDate", "End Date")}:
                </div>
                <div>
                  {formatDate(item.endDate)}
                </div>
              </div>
            }
            {item?.registerStartDate &&
              <div class="showNewLocation showNewStartDate">
                <div>
                  <i class="fa fa-calendar red" ></i>
                  {translate(
                    "web.registerStartDate",
                    "Register Start Date"
                  )}:
                </div>
                <div>
                  {formatDate(item?.registerStartDate)}
                </div>
              </div>
            }
            {item?.registerEndDate &&
              <div class="showNewLocation showNewStartDate">
                <div>
                  <i class="fa fa-calendar red" ></i>
                  {translate(
                    "web.registerEndDate",
                    "Register End Date"
                  )}:
                </div>
                <div>
                  {formatDate(item?.registerEndDate)}
                </div>
              </div>
            }
            {item?.registerStartDateInter &&
              <div class="showNewLocation showNewStartDate">
                <div>
                  <i class="fa fa-calendar red" ></i>
                  {translate(
                    "web.registerStartDateInter",
                    "Register Start Date Inter"
                  )}:
                </div>
                <div>
                  {formatDate(
                    item?.registerStartDateInter
                  )}
                </div>
              </div>
            }
            {item?.registerEndDateInter &&
              <div class="showNewLocation showNewStartDate">
                <div>
                  <i class="fa fa-calendar red" ></i>
                  {translate(
                    "web.registerEndDateInter",
                    "Register End Date Inter"
                  )}
                  :
                </div>
                <div>
                  {formatDate(
                    item?.registerEndDateInter
                  )}
                </div>
              </div>
            }
            <div class="showNewLocation showNewStartDate">
              <div>
                <img src={getDirhamImage(currentLanguage)} alt='AED' style={aedLogoStyle} />
                {translate(
                  "web.fees",
                  "Fees"
                )}
                :
              </div>
              <div className='fw-bold'>
                {item.entryFees} {translate('web.aed', 'AED')}
              </div>
            </div>
            <div class="showNewStartDate showNewLocation mb-form-group">
              <div>
                <i class="fa-solid fa-chess-knight red" ></i>
                {translate(
                  "web.maxNoPerOwner",
                  "Max no of horses to register per owner"
                )}
                :
              </div>
              <div className='fw-bold'>
                {item.maxHorseNumberPerOwner > 0
                  ? item.maxHorseNumberPerOwner
                  : translate(
                    "web.unlimited",
                    "Unlimited"
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row  ">
        <div className="col-md-6 col-sm-12 text-start ">
          {(item?.isLocalRegistrationOpen != true && item?.isInternationalRegistrationOpen != true && item?.isFoalRegistrationOpen != true) ?

            <>
              {item?.showParticipantRequestStatus != 'New' ?
                <>
                  <PillBtn
                    isNoMargin
                    routeName={
                      `/showParticipate?showId=${item.id}`}
                    text={translate(
                      "web.continue",
                      "Continue"
                    )
                    }
                    isRed={true}
                  />
                </> : <></>
              }
            </>
            :
            item.showParticipantRequestStatus != "New" ?

              <PillBtn
                isNoMargin
                routeName={
                  `/showParticipate?showId=${item.id}`}
                text={translate(
                  "web.continue",
                  "Continue"
                )
                }
                isRed={true}
              />
              : <PillBtn
                isNoMargin
                routeName={
                  `/showParticipate?showId=${item.id}`}
                text={translate(
                  "web.participateNow",
                  "Participate Now"
                )
                }
                isRed={true}
              />

          }
          {item.isShowJudgesAdded &&
            item.showParticipantRequestStatus ===
            "Completed" &&
            CompareDate(
              item.registerStartDate,
              item.startDate
            ) && (
              <PillBtn classes='mt-2' text={translate(
                "web.addConflict",
                "Add Conflict"
              )}
                isNoMargin
                routeName={`/showentryconflict?maxHorses=${item.maxHorseNumberPerOwner}&showNameAr=${item.showNameAr}&showNameEn=${item.showNameEn}&showId=${item.id}`}
                isNoAction={CompareDate(
                  item.registerStartDate,
                  item.startDate
                )
                  ? false
                  : true}
                isDisabled={CompareDate(
                  item.registerStartDate,
                  item.startDate
                )
                  ? false
                  : true}
              />
            )}
          {item.showParticipantRequestStatus ===
            "Completed" &&
            item.IsShowRegisterStarted == true &&
            (item.maxHorseNumberPerOwner >
              item.completedRequestsCount ||
              item.maxHorseNumberPerOwner == 0) && (
              <PillBtn
                isNoMargin
                text={new Date() >
                  new Date(item.registerEndDate) ? (
                  <>
                    {translate(
                      "web.continue",
                      "Continue"
                    )}
                  </>
                ) : (
                  <>
                    {translate(
                      "web.addAdditionalHorse",
                      "Add Additional Horse"
                    )}
                  </>
                )}
                routeName={`/showentrycard?entryFees=${item.entryFees}&maxHorses=${parseInt(
                  item.maxHorseNumberPerOwner
                )}&showNameAr=${item.showNameAr}&showNameEn=${item.showNameEn}&showId=${item.id}&showParticipantRequestStatus=${item.showParticipantRequestStatus}&registerStartDate=${item.registerStartDate}&registerEndDate=${item.registerEndDate}&registerStartDateInter=${item.registerStartDateInter}&registerEndDateInter=${item.registerEndDateInter}&showStartDate=${item.startDate}`} isNoAction={!CompareDate(
                  item.registerStartDate,
                  item.endDate
                )} />
            )}
        </div>

        <div className="col-md-6 col-sm-12 text-end ">
          <PillBtn
            isNoMargin
            text={translate(
              "web.viewDetails",
              "View Details"
            )} routeName={`/showentrydetails?showId=${item.id}`} />
        </div>
      </div>
    </div>
  </div>
}
